/** Simple URL check for branding link fields (mirrors dq-seal-client). */

export const isHttpUrl = (url) => {
    if (!url || typeof url !== 'string') return false;
    const t = url.trim();
    if (!t) return false;
    return /^https?:\/\//i.test(t) || /\/local\//i.test(t) || /\/branding\//i.test(t);
};
